import { create } from 'zustand';

export type ModalConfirmVariant = 'danger' | 'warning' | 'info';

type ModalConfirmItem = {
    id: string;
    message: string;
    subMessage?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    variant?: ModalConfirmVariant;
};

type ModalConfirmStore = {
    isOpen: boolean;
    currentConfirm: ModalConfirmItem | null;
    openModalConfirm: (item: ModalConfirmItem) => void;
    closeModalConfirm: () => void;
};

export const useModalConfirmStore = create<ModalConfirmStore>((set) => ({
    isOpen: false,
    currentConfirm: null,

    openModalConfirm: (item) => {
        set({ isOpen: true, currentConfirm: item });
    },

    closeModalConfirm: () => {
        set({ isOpen: false });
        setTimeout(() => set({ currentConfirm: null }), 300);
    },
}));
